import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../../utils/styles';
import Button from '../../Button';

const SuccessContainer = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    & > div {
        max-width: 600px;
    }

    & > div > i { 
        font-size: 4rem; 
        margin-bottom: 0.5em; 
    }
    
    & > div > p { 
        line-height: 1.75; 
        margin: 1em 0; 
    }
`;

const StyledButton = styled(Button)`
  margin: 1.5em 0;
    padding-left: 1.5em;
    padding-right: 1.5em;
    width: auto;

    @media screen and (min-width: ${breakpoints.desktop}px) {
        margin: 1em 0;
    }
`;

const ErrorContainer = styled.div`
    text-align: center;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    & > div {
        max-width: 600px;
    }

    & > div > i { 
        font-size: 4rem; 
        margin-bottom: 0.5em; 
        color: #dc3545;
    }
    
    & > div > h1, & > div > h2 { 
        color: var(--text-primary); 
        font-weight: 700; 
    }
    
    & > div > p { 
        line-height: 1.75; 
        margin: 1em 0; 
    }
`;

const PaymentSuccessTitle = styled.h1`
  color: var(--text-primary) !important;
  font-family: var(--ff-title);
  font-size: 4rem !important;
  font-weight: 400;
  margin-bottom: 5%;
  text-transform: uppercase;
`;

const PaymentSuccessSubtitle = styled.h2`
  color: var(--text-primary) !important;
  font-family: var(--ff-subtitle);
  font-size: 2rem !important;
  margin: 1em 0 1.5em !important;
`;


interface Props {
    onBack?: () => void,
    title?: string,
    subtitle?: string,
    content?: React.ReactNode,
    buttons?: React.ReactNode,
}

const PurchaseSuccessMessage = ({
    title = "¡Pago exitoso!",
    subtitle = "Tu compra ha sido procesada correctamente",
    content,
    buttons,
}: Props) => (
    <SuccessContainer className="fade-in">
        <div>
            <i className="fa-light fa-circle-check"></i>
            <PaymentSuccessTitle>{title}</PaymentSuccessTitle>
            <PaymentSuccessSubtitle>{subtitle}</PaymentSuccessSubtitle>

            {content ? content : null}

            {buttons && <div className='pt-3'>
                {buttons}
            </div>}
        </div>
    </SuccessContainer>
);

export default PurchaseSuccessMessage;